import React from 'react';
import PropTypes from 'prop-types';
import ForwardButton from 'components/ForwardButton';
import styles from '../ActivityContainer.module.scss';

const ActivitySkipper = ({ onClick }) => (
  <div className={styles.errorBoundry}>
    <h1>Activity does not exist (yet).</h1>

    <ForwardButton onClick={onClick} />
  </div>
);

ActivitySkipper.propTypes = {
  onClick: PropTypes.func
};

export default ActivitySkipper;
